import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import SEO from '../SEO'
import ContentBlock from '../Common/ContentBlock/ContentBlock'
import * as Yup from 'yup'
import { emailSchema, validateSchema } from '../../helpers/formHelper'
import _isEmpty from 'lodash.isempty'
import clsx from 'clsx'
import { publicApi } from '../../axios'
import { apiUrls } from '../../helpers/apiHelper'
import { useAlert } from '@ezrirx/sourdough'
import { SuccessToast } from '../Common/ToastAlerts'

const ForgotPassword = (props) => {
  const { t } = useTranslation()

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState({})

  const { history } = props
  const alert = useAlert()

  const handleSubmitForm = async (e) => {
    e.preventDefault()

    const { errors: validatedErrors } = await validateSchema(
      Yup.object().shape({
        email: emailSchema
      }),
      { email }
    )
    setErrors(validatedErrors)
    if (_isEmpty(validatedErrors)) {
      publicApi
        .post(apiUrls.user.resetPassword, { email })
        .then(() => {
          alert.success(<SuccessToast body={t('user.send_instructions')} />, {
            alertType: 'modal'
          })
          history.push('/login')
        })
        .catch((err) => {
          alert.failure(
            err.response?.data?.message || t('response.an_error_occurred')
          )
        })
    }
  }

  return (
    <>
      <SEO
        title={t('page_titles.sign_in')}
        pathName={history.location.pathname}
      />
      <div className="layout-default login">
        <div className="contents">
          <h1 className="logo">
            <Link to="/" />
          </h1>
          <ContentBlock>
            <ContentBlock.Heading>
              {t('auth.forgot_password')}
            </ContentBlock.Heading>
            <ContentBlock.Body>
              <form onSubmit={(e) => handleSubmitForm(e)}>
                <div className="content-block__container__main">
                  <div className="row margin-bottom-20 mx-0">
                    <div className="form-group col-12 px-0">
                      <label htmlFor="email">{t('user.email')}</label>
                      <input
                        type="text"
                        id="email"
                        className={clsx('lg full-width', {
                          error: errors.email
                        })}
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        autoCorrect="off"
                        autoComplete="off"
                        autoCapitalize="none"
                      />
                      {errors.email && (
                        <em className="error">{errors.email}</em>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <button
                        type="submit"
                        className="lg block button"
                        disabled={email.length === 0}
                      >
                        {t('auth.reset_my_password')}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </ContentBlock.Body>
          </ContentBlock>

          <p className="footer-text">
            {t('auth.already_have_account')}{' '}
            <Link to="/login/">{t('auth.sign_in_here')}</Link>
          </p>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
